module.exports = "https://trybtryb-legacy.web.app/img/berry.021a7b18.webp";